import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';

import FavoriteIcon from '@icons/FavoriteIcon';
import { LoggedInContext } from '../../../context/LoggedInProvider';
import getFavoriteHook from '@hooks/getFavoriteHook';

const FavoriteButtonCompany = ({ recordID, isFavorite }) => {
    const { isLoggedIn } = useContext(LoggedInContext);
    const useFavorite = getFavoriteHook({ type: 'company', initialIsFavorite: isFavorite });
    const { isLoadingFavorite, saveFavorite, removeFavorite } = useFavorite();

    const onFavorite = async () => {
        if (isFavorite) {
            await removeFavorite(recordID);
        } else {
            saveFavorite(recordID);
        }
    };

    return (
        <FavoriteIcon
            id={recordID}
            type="company"
            isLoggedIn={isLoggedIn}
            isFavorite={isFavorite}
            isLoading={isLoadingFavorite}
            tooltipLabel="Company"
            onClick={() => onFavorite()}
        />
    );
};

FavoriteButtonCompany.propTypes = {
    recordID: PropTypes.number,
    isFavorite: PropTypes.bool.isRequired,
};

export default FavoriteButtonCompany;
